import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EditModal, { specialtyPropertyTypesPropTypes } from './edit_modal';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray } from '../shared';
import Button from 'shared/button';

export default function Specialties(props) {
  const [specialties, setSpecialties] = useState(props.specialties);
  const [modalObject, setModalObject] = useState({ isOpen: false, id: '' });
  const [error, setError] = useState('');

  const openModal = id => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const specialtyToEdit = modalObject.id === '' ? null : specialties.find(specialty => specialty.id === modalObject.id);

  const handleFormSubmit = (newSpecialty) => {
    modifyRecordArray(newSpecialty, setSpecialties, specialties, 'title', modalObject, closeModal);
  };

  const deleteSpecialty = ({ title, id }) => {
    deleteRecord(id, title, '/broker_specialties', 'Specialty', setSpecialties, setError);
  };

  const addNewSpeciality = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        dialogClassName="modal-sm"
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          groupSpecialties={props.groupSpecialties}
          id={modalObject.id}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          propertyType={specialtyToEdit?.propertyType}
          specialtyPropertyTypes={props.specialtyPropertyTypes}
          title={specialtyToEdit?.title}
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 align-items-center top-buffer-xl">
        <h2 className="m-0">Broker & Company Specialties</h2>
        <Button.Primary onClick={addNewSpeciality}>Add Specialty</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Specialty"
        deleteRecord={deleteSpecialty}
        firstColumnIdentifier="title"
        openModal={openModal}
        recordName="Specialty"
        records={specialties}
        secondColumnIdentifier="propertyType"
        onClick={addNewSpeciality}
      />

    </React.Fragment>
  );
}

export const specialtiesPropTypes = {
  specialties: PropTypes.arrayOf(PropTypes.shape({
    canModify: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    propertyType: PropTypes.string
  }))
};



Specialties.propTypes = {
  groupSpecialties: PropTypes.bool.isRequired,
  ...specialtiesPropTypes,
  ...specialtyPropertyTypesPropTypes
};
